export default __webpack_public_path__ + "static/media/blue-play.3da82aad.svg";